// extracted by mini-css-extract-plugin
export var container = "memberships-logos-module--container--57b4c";
export var heading = "memberships-logos-module--heading--7cc38";